import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

import styles from "./CharacterCount.css";

export default class CharacterCount extends React.Component {
  render() {
    const className = classNames(styles.root, {
      [styles.warning]:
        this.props.warningLength &&
        this.props.count >= this.props.warningLength,
      [styles.transparent]: !this.props.visible,
    });

    return (
      <div className={className}>
        {`${this.props.count} character${this.props.count === 1 ? "" : "s"}`}
      </div>
    );
  }
}

CharacterCount.defaultProps = {
  visible: true,
};

CharacterCount.propTypes = {
  count: PropTypes.number.isRequired,
  warningLength: PropTypes.number,
  visible: PropTypes.bool,
};
